// @flow
import _ from 'lodash';
import moment from 'moment';

import ApiManager from './ApiManager';

// -- constants
import APIEndpoints from '../constants/APIEndpoints';

// -- utils
import DateUtils from '../utils/DateUtils';

// -- entities
import ApiError from '../entities/ApiError';
import ProRole from '../entities/security/ProRole';
import ProRolesList from '../entities/security/ProRolesList';


class ApiRole {

  //
  // RestaurantsGroup Roles
  //

  static getRestaurantsGroupRoles(restaurantGroupIp: string, success: Function, failure: Function) {
    const endpoint = APIEndpoints.RESTAURANTS_GROUP_ROLES.replace(':restaurantsGroupId', restaurantGroupIp);

    const requestOptions = {
      endpoint,
      query: {},
      success: (json: Object) => {

        const proRolesList: ProRolesList = new ProRolesList();
        proRolesList.fromJson(json);

        success(proRolesList);
      },
      failure: (apiError: ApiError) => {
        failure(apiError);
      }
    }

    ApiManager.get(requestOptions);
  }

  //
  // Role
  //

  static putRole(proRoleToUpdate: ProRole, success: Function, failure: Function) {
    const endpoint = APIEndpoints.PRO_ROLE.replace(':roleId', proRoleToUpdate.id);


    const requestOptions = {
      endpoint,
      data: proRoleToUpdate,
      success: (json: Object) => {

        const proRole:ProRole = new ProRole();
        proRole.fromJson(json);

        success(proRole);
      },
      failure: (apiError: ApiError) => {
        failure(apiError);
      }
    }

    ApiManager.put(requestOptions);
  }

  static postRole(proRoleToCreate: ProRole, success: Function, failure: Function) {
    const endpoint = APIEndpoints.PRO_ROLES;

    const requestOptions = {
      endpoint,
      data: proRoleToCreate,
      success: (json: Object) => {

        const proRole:ProRole = new ProRole();
        proRole.fromJson(json);

        success(proRole);
      },
      failure: (apiError: ApiError) => {
        failure(apiError);
      }
    }

    ApiManager.post(requestOptions);
  }

  static deleteRole(proRole: ProRole, success: Function, failure: Function) {
    const endpoint = APIEndpoints.PRO_ROLE.replace(':roleId', proRole.id);

    const requestOptions = {
      endpoint,
      success: (json: Object) => {
        success(proRole);
      },
      failure: (apiError: ApiError) => {
        failure(apiError);
      }
    }

    ApiManager.delete(requestOptions);
  }

  static getRole(proRoleId: string, success: Function, failure: Function) {
    const endpoint = APIEndpoints.PRO_ROLE.replace(':roleId', proRoleId);

    const requestOptions = {
      endpoint,
      success: (json: Object) => {

        const proRole:ProRole = new ProRole();
        proRole.fromJson(json);

        success(proRole);
      },
      failure: (apiError: ApiError) => {
        failure(apiError);
      }
    }

    ApiManager.get(requestOptions);
  }

  static getRoleWithDomain(proRoleId: string, domainId: number, success: Function, failure: Function) {
    const endpoint = APIEndpoints.PRO_ROLE.replace(':roleId', proRoleId);

    const requestOptions = {
      endpoint,
      headers: {
        'pro-domain-id': domainId,
      },
      success: (json: Object) => {

        const proRole:ProRole = new ProRole();
        proRole.fromJson(json);

        success(proRole);
      },
      failure: (apiError: ApiError) => {
        failure(apiError);
      }
    }

    ApiManager.get(requestOptions);
  }
}

export default ApiRole;
